//import 'bootstrap';
import { gsap } from "gsap";
import "./animations.js";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
gsap.registerPlugin( ScrollToPlugin);
$(document).ready(() => {
  const hamb = document.querySelector("#hamb");
  const mainNav = document.querySelector("#main-nav");
  const overlay = document.querySelector("#overlay");
  const closeMenuBtn = document.querySelector("#close-menu");
  const searchBtn = document.querySelector("#search-btn");
  const closeSearchBtn = document.querySelector("#close-search-btn");
  const searchModal = document.querySelector("#search-modal");


  // floating labels for gform inputs with top label
  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).on("focus", function () {
    console.log("focusing");
    $(this).parent().parent(".gfield").addClass("active");
  });

  $(
    "form .top_label .gfield .ginput_container input, form .top_label .gfield .ginput_container textarea"
  ).on("blur", function () {
    if ($(this).val().length == 0) {
      $(this).parent().parent(".gfield").removeClass("active");
    }
  });

  // footer subscribe menu animation
  $(document).on("gform_confirmation_loaded", function (e, form_id) {
    // code to run upon successful form submission
    console.log("event:", e, "\nid:", form_id);
    if (form_id == 2) {
      showFooterSubscibeConfirmation();
    }
  });

  function showFooterSubscibeConfirmation() {
    document
      .querySelector("#footer-subscribe .absolute")
      .classList.remove("translate-y-full");
  }

  hamb.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openMenu();
    },
    false
  );

  closeMenuBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeMenu();
    },
    false
  );

  searchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      openSearch();
    },
    false
  );

  closeSearchBtn.addEventListener(
    "click",
    function (e) {
      e.stopPropagation();
      closeSearch();
    },
    false
  );

  // opens the search
  function openSearch() {
    console.log("opensearch function");
    searchModal.classList.remove("hidden");
  }

  // closes the search
  function closeSearch() {
    searchModal.classList.add("hidden");
  }

  // opens main nav
  function openMenu() {
    console.log("opening nav");
    mainNav.classList.remove("-translate-y-full");
    mainNav.classList.add("translate-y-0");
    overlay.classList.remove("hidden");
  }

  // closes main nav
  function closeMenu() {
    console.log("closing nav");
    mainNav.classList.add("-translate-y-full");
    mainNav.classList.remove("translate-y-0");
    overlay.classList.add("hidden");
  }

  function toggleBodyLock() {
    if (document.querySelector("body").classList.contains("locked")) {
      document.querySelector("body").classList.remove("locked");
    } else {
      document.querySelector("body").classList.add("locked");
    }
  }



  var dropdowns = document.querySelectorAll(".dropdown");
  var viewportWidth = $(window).width();
  console.log(viewportWidth);

  $("body").click(function () {
    //closeSearch();
    closeAllDropDowns();
  });

  $(window).scroll(function () {
    if (viewportWidth <= 1023) {
      //console.log("mobile scroll");
      return;
    } else {
      //console.log("desktop scroll");
      closeSearch();
      closeAllDropDowns();
    }
  });

  function closeAllDropDowns() {
    $("header").removeClass("active");
    $(".underlay").removeClass("active");
    $(dropdowns).each(function () {
      $(this).removeClass("open");
    });
  }
  // close menu
  closeMenu();

  // animate on scroll library
  AOS.init();
});
